module.exports = __webpack_public_path__ + "media/images/illustration_1-9348590091f67bc42e3a63f1c0f60159.svg";